import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import {Icon} from 'leaflet'

/* import { TileLayer } from 'react-leaflet/TileLayer';
import { Marker } from 'react-leaflet/Marker';
import { Popup } from 'react-leaflet/Popup'; */

function LocationMap(props) {

    const MapRecenter= ({ lat, lng, zoomLevel }) => {
      const map = useMap();
    
      useEffect(() => {
        // Fly to that coordinates and set new zoom level
        map.setView([lat, lng], zoomLevel );
      }, [lat, lng]);
      return null;
    
    };

    // console.warn('props di location map', props);
    return (
        <MapContainer center={[props.location.longitude,props.location.latitude]} zoom={17} scrollWheelZoom={false} style={{ width: "100%", height: "45vh" }}>
          <MapRecenter lat={props.location.longitude} lng={props.location.latitude} zoomLevel={17} />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[props.location.longitude,props.location.latitude]} icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}>
            <Popup>
                <b>{props.location.name}</b>
                <br />
              {props.location.address}
            </Popup>
          </Marker>
        </MapContainer>
    );
}

export default LocationMap;